(() => {
  'use strict';
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const targets = '.ze-opening__registry, .ze-opening__notes, .za-collection-heading, .product-grid .product-grid__item, .zc-lab, #zaiko-store .zl-section-heading, #zaiko-store .zl-object, #zaiko-store .zp-format-section > .z-container > h2, #zaiko-store .zp-formats a, #zaiko-store .zg-guide, #zaiko-store .zb-trust-section .z-trust-grid > div, #zaiko-store .zf-brand, #zaiko-store .za-faq-intro, .za-footer-navigation > div';
  let observer;
  const play = (element, frames, options) => {
    if (!element || preference.matches || typeof element.animate !== 'function') return;
    const animation = element.animate(frames, options);
    running.add(animation);
    const done = () => running.delete(animation);
    animation.addEventListener('finish', done, { once: true });
    animation.addEventListener('cancel', done, { once: true });
    return animation;
  };
  const reveal = (element, delay) => {
    element.dataset.zaRevealed = 'true';
    play(element, [
      { opacity: 0, transform: 'translateY(36px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 850, delay, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
  };
  const scan = () => {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      let order = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(order++ * 100, 300));
      }
    }, { threshold: .12, rootMargin: '0px 0px -24px 0px' });
    document.querySelectorAll(targets).forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      observer.observe(element);
    });
  };
  preference.addEventListener('change', () => {
    observer?.disconnect();
    observer = undefined;
    running.forEach(animation => animation.cancel());
    running.clear();
    document.querySelectorAll(targets).forEach(element => seen.delete(element));
    scan();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => {
    running.forEach(animation => {
      if (!animation.effect?.target?.isConnected) animation.cancel();
    });
  });
})();
